module.exports = __webpack_public_path__ + "static/img/background-jh.79971368.jpg";